export default __webpack_public_path__ + "ui/assets/img/delete-16-disabled.svg";